import {
  faArrowRotateRight,
  faCirclePlus,
  faGear,
  faLineChart,
  faPhone,
  faWallet,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AutoPopulateFieldHooks } from "./hooks/sidebar";

const CSideBar = () => {
  const [isActive, setIsActive] = useState("portal");
  const [helloName, setHelloName] = useState({});

  useEffect(() => {
    getField();
  }, []);

  // To get username using AutoPopulateFieldHooks
  
  const getField = async () => {
    const getName = await AutoPopulateFieldHooks();
    setHelloName(getName.data);
  };

  return (
    <>
      {/* <div id="mobile_sidebar" className="collapse"> */}
        <div id="layoutSidenav_nav">
          <nav className="sidenav shadow shadow-right sidenav-light">
            <div className="sidenav-menu">
              <div className="nav accordion" id="accordionSidenav">
                <div className="sidenav-menu-heading text-primary-new">
                  Hello {helloName.firstname + " " + helloName.lastname}!
                </div>
                <Link
                  className={`nav-link ${
                    isActive === "portal" ? "activeTab" : ""
                  }`}
                  to={"/dashboard"}
                  onClick={() => setIsActive("portal")}
                >
                  <FontAwesomeIcon icon={faLineChart} className="me-2" />
                  My Portals
                </Link>
                <Link
                  className={`nav-link ${
                    isActive === "newOrders" ? "activeTab" : ""
                  }`}
                  to={"new-orders"}
                  onClick={() => setIsActive("newOrders")}
                >
                  <FontAwesomeIcon icon={faCirclePlus} className="me-2" /> New
                  Orders
                </Link>
                <Link
                  className={`nav-link ${
                    isActive === "previousOrders" ? "activeTab" : ""
                  }`}
                  to={"previous-orders"}
                  onClick={() => setIsActive("previousOrders")}
                >
                  <FontAwesomeIcon icon={faArrowRotateRight} className="me-2" />{" "}
                  All Orders
                </Link>
                {/* <Link
                  className={`nav-link ${
                    isActive === "payments" ? "activeTab" : ""
                  }`}
                  to={"payments"}
                  onClick={() => setIsActive("payments")}
                >
                  <FontAwesomeIcon icon={faWallet} className="me-2" /> Payments
                </Link> */}
                <div className="fixed-bottom">
                  <Link
                    className={`nav-link ${
                      isActive === "contactus" ? "activeTab" : ""
                    }`}
                    to={"contact-us"}
                    onClick={() => setIsActive("contactus")}
                  >
                    <FontAwesomeIcon icon={faPhone} className="me-2" /> Contact
                    Us
                  </Link>
                  <Link
                    className={`nav-link mb-4 ${
                      isActive === "settings" ? "activeTab" : ""
                    }`}
                    to={"settings"}
                    onClick={() => setIsActive("settings")}
                  >
                    <FontAwesomeIcon icon={faGear} className="me-2" /> Settings
                  </Link>
                </div>
              </div>
            </div>
          </nav>
        </div>
    </>
  );
};
export default CSideBar;
